<div class="home-block">
  <!-- <div class="home-block-header">Powered by <b>KANTAR</b></div> -->
  <div class="setting-block-header"></div>
  <div class="setting-icon" *ngIf="settingIconShown">
    <!-- <div class="notification-icon" [ngClass]="{'active': triggerNew}" (click)="toggleNotification()"></div> -->
    <div class="notification-icon" *ngIf="showBellIcon" [ngClass]="{ 'active': hasNewNotifications }"
      (click)="toggleNotificationPanel()" DocumentClick
      (DocumentClicked)="showNotificationPanel = false">
      <img class="notification-img"
        [src]="hasNewNotifications ? 'assets/images/aesthetics/notification_active.svg' : 'assets/images/aesthetics/notification_normal.svg'"
        alt="Notifications"/>
    </div>
    <img
      [src]="toggleSetting ? '../../../../assets/images/common/aesthetics/SettingsClickIcon.svg' : '../../../../assets/images/common/Settings Icon.svg'"
      [ngStyle]="{'z-index': toggleSetting ?'99999':'0'}" style="width:1.3rem; height:1.3rem"title="setting" alt="setting" (click)="OnSettingClick()"/>
    </div>
    <!-- <div class="setting-panel" [ngClass]="{'open': toggleSetting, 'closed': !toggleSetting}">

    <div class="setting-blocks" *ngIf="exportDownloads" title="Export Downloads" (click)="OnExportsDownloads()">
      <div class="setting-block-icon export-download-icon"></div>
      <div class="setting-block-name">Export Downloads</div>
    </div>

    <div *ngIf="isHelpGuide" class="setting-blocks" title="Help Guide" (click)="onUserGuideClick()">
      <div class="setting-block-icon user-guide"></div>
      <div class="setting-block-name">Help Guide</div>
    </div>

    <div *ngIf="isDocumentRepository" class="setting-blocks" title="Document Repository">
      <div class="setting-block-icon doc-repo-icon"></div>
      <div class="setting-block-name">Document Repository</div>
    </div>

    <div class="setting-blocks" title="User Management" (click)="onUserManagementClick()">
      <div class="setting-block-icon user-management-icon"></div>
      <div class="setting-block-name">User Management</div>
    </div>

    <div class="setting-blocks" title="Report An Issue" (click)="OnReportIssue()">
      <div class="setting-block-icon report-issue-icon"></div>
      <div class="setting-block-name">Report An Issue</div>
    </div>

    <div class="setting-blocks" title="Log out" (click)="LogOut()">
      <div class="setting-block-icon logout-icon"></div>
      <div class="setting-block-name">Log out</div>
    </div>
  </div> -->
 


<div class="home-icon" title="Home" (click)="redirectToLandingPage()">
  <img src="../../../../assets/images/common/Home Icon.svg" alt="Home">
</div>
</div>

<!-- <app-notification-panel
  [showNotification]="showNotification"
  [notifications]="notifications"
  [notificationCount]="notificationCount"
  [showClearAll]="showClearAll"
  (notificationClick)="onNotificationClick($event.notification, $event.event)"
 (clearAllClick)="clearAll($event)"
  (panelClick)="$event.stopPropagation()">
</app-notification-panel> -->

<app-notification-panel
  
  [(isOpen)]="showNotificationPanel"
  (notificationCountChange)="onNotificationCountChange($event)">
</app-notification-panel>

<app-export-downloads-popup (closePopup)="onCloseExportDownloads()" [showExportsDownloads]="showExportsDownloadsPopup"
  *ngIf="showExportsDownloadsPopup" [ReportInput]="exportReportInput"></app-export-downloads-popup>

<div class="settingComponent" *ngIf="toggleSetting">
<app-setting [docClick]="isDocumentRepository" [hasDocuments]="hasDocuments" [handleDocumentClick]="HandleDocumentClick.bind(this)" (OnSettingClick)="settingOptionSel($event)" [helpGuide]="isHelpGuide" [moduleName]="moduleName"></app-setting>
</div>
